import React from 'react'

import Link from 'components/common/Link'
import { getCustomerDetailsPageUrl } from 'router/routes'

const NEW_TAB_PROPS = { target: '_blank', rel: 'noopener noreferrer' }

interface RenderAccountLinkCellProps {
  value?: React.ReactNode
  row?: { accountId?: string | null }
  openInNewTab?: boolean
}

const handleLinkClick = (event: React.MouseEvent) => event.stopPropagation()

const RenderAccountLinkCell = ({ value, row, openInNewTab = false }: RenderAccountLinkCellProps) => (
  <Link to={getCustomerDetailsPageUrl(row?.accountId || '')} onClick={handleLinkClick} {...(openInNewTab && NEW_TAB_PROPS)}>
    {value}
  </Link>
)

export default RenderAccountLinkCell
